import React from "react";

import "./index.scss";
import Sidebar from "../sidebar";
import Header from "../headerAdmin";

const AppLayoutAdmin = ({ children }) => {
  return (
    <div className="app-layout-admin1">
      <Sidebar />
      <div className="main-content-admin1">
        <Header />
        <div className="children-content-admin1">{children}</div>
      </div>
    </div>
  );
};

export default AppLayoutAdmin;
